import { render, staticRenderFns } from "./RemoteController.vue?vue&type=template&id=fec06972&scoped=true"
import script from "./RemoteController.vue?vue&type=script&lang=js"
export * from "./RemoteController.vue?vue&type=script&lang=js"
import style0 from "./RemoteController.vue?vue&type=style&index=0&id=fec06972&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec06972",
  null
  
)

export default component.exports